import _regeneratorRuntime from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { Subject, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { ArgumentsError, ConnectionCutError, ConnectionCutType, ConnectionKeyInUseError, QuotaCheckError, SessionNotAvailableError, SessionNotFoundError, SessionProvisioningError } from '../types/errors';
import { Http } from '../utils/http';
import { Sdp } from '../utils/sdp';
var DefaultLimits = {
  minBitrate: 0,
  maxBitrate: 15000,
  startBitrate: 5000
};
export var StreamingService =
/*#__PURE__*/
function () {
  /**
   * <img src="../../architecture.png" alt="alt text">
   * This constructor constructs SignalService taking in ServiceOption as parameters.
   * @param serviceOptions : This is ServiceOption type with properties: baseUrl, appEnvId, and apiKey
   * This constructs Signaling service by taking the parameters from ServiceOption type.
   * @Returns This return the SeramingService
   */
  function StreamingService(serviceOptions) {
    _classCallCheck(this, StreamingService);

    this.serviceOptions = serviceOptions;
    this.streamSource = new Subject();
    if (!serviceOptions.baseUrl) throw new ArgumentsError('baseUrl has to be set');
    if (!serviceOptions.appEnvId) throw new ArgumentsError('appEnvId has to be set');
    this.signaling = new SignalingService(serviceOptions);
    this.stopping = false;
  }
  /**
   *
   * @param sessionOptions This type parameter includes: participants(can be null), immediate(true/false or null), requiredSpecs(can be null), optionalSpecs(Can be null), sessionSpecs(can be null).
   * @param streamOptions This type parameter(can be null) includes: UseAudio(can be null) StreamLimits(can be null), CutStreamLimits(can be null).
   * @returns It returs observable of type StreamInfo including data for MediaStream, Ip, Session and Specs.
   */


  _createClass(StreamingService, [{
    key: "start",
    value: function start(sessionOptions, streamOptions) {
      var ret$ = this.prepareStream(streamOptions).pipe(map(function (info) {
        return info;
      }));
      this.startInternal(sessionOptions);
      return ret$;
    }
    /**
     *
     * @param provisioningSession This type parameter can includes: checkBackIn, expiration, mainConnection, secondaryConnectoin(can be null)
     * @returns It returs observable of type StreamInfo including data for MediaStream, Ip, Session and Specs.
     */

  }, {
    key: "startProvisioningSession",
    value: function startProvisioningSession(provisioningSession) {
      var ret$ = this.prepareStream().pipe(map(function (info) {
        return info;
      }));
      this.startPollingForProvisioningSession(provisioningSession);
      return ret$;
    }
    /**
     *
     * @param session This type parameter includes: reservationId, expiration, renderer(can be null), mainConnection, secondaryConnection(can be null)
     * @returns It returs observable of type StreamInfo including data for MediaStream, Ip, Session and Specs.
     */

  }, {
    key: "connect",
    value: function connect(session) {
      var ret$ = this.prepareStream().pipe(map(function (info) {
        return info;
      }));
      this.connectInternal(session);
      return ret$;
    }
    /**
     *
     * @param connectionKey This parameter is a unique connecton key
     * @param streamOptions This type parameter(can be null) includes: UseAudio(can be null) StreamLimits(can be null), CutStreamLimits(can be null).
     * @returns It returs observable of type ClientStreamInfo MediaStream, Ip, Session and Specs.
     */

  }, {
    key: "startWithConnectionKey",
    value: function startWithConnectionKey(connectionKey, streamOptions) {
      var ret$ = this.prepareStream(streamOptions).pipe(map(function (info) {
        return info;
      }));
      this.startWithConnectionKeyInternal(connectionKey);
      return ret$;
    }
    /**
     *
     * @param connectionCode This parametr is number code.
     * @param streamOptions This type parameter(can be null) includes: UseAudio(can be null) StreamLimits(can be null), CutStreamLimits(can be null).
     * @returns It returs observable of type ClientStreamInfo MediaStream, Ip, Session and Specs.
     */

  }, {
    key: "startWithConnectionCode",
    value: function startWithConnectionCode(connectionCode, streamOptions) {
      var ret$ = this.prepareStream(streamOptions).pipe(map(function (info) {
        return info;
      }));
      this.startWithConnectionCodeInternal(connectionCode);
      return ret$;
    }
    /**
     *
     * @param sessionOptions This type parameter includes: participants(can be null), immediate(true/false or null), requiredSpecs(can be null), optionalSpecs(Can be null), sessionSpecs(can be null).
     * @returns It returns Promise of type boolean(either true or false)
     */

  }, {
    key: "checkQuota",
    value: function () {
      var _checkQuota = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(sessionOptions) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Http.post(this.serviceOptions, '/api/v1/session/quota', sessionOptions);

              case 2:
                response = _context.sent;

                if (!(response.Status === 404)) {
                  _context.next = 7;
                  break;
                }

                throw new QuotaCheckError('app env not found');

              case 7:
                if (!(response.Status < 200 || response.Status > 299)) {
                  _context.next = 9;
                  break;
                }

                throw new QuotaCheckError('unexpected error');

              case 9:
                return _context.abrupt("return", response.Data.isInQuota);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkQuota(_x) {
        return _checkQuota.apply(this, arguments);
      }

      return checkQuota;
    }()
    /**
     *
     * @param err It takes Error type as parameter if there is any.
     * @returns If the session is stopping, it returns void.
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(err) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.stopping) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return this.signaling.signOut();

              case 5:
                _context2.next = 9;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](2);

              case 9:
                this.stopping = true;
                this.stopMonitoring();

                if (this.connection) {
                  this.connection.close();
                  delete this.connection;
                  this.connection = null;
                }

                if (this.streamSource) {
                  if (err) {
                    this.streamSource.error(err);
                  } else {
                    this.streamSource.next(null);
                    this.streamSource.complete();
                  }

                  this.streamSource = new Subject();
                }

                this.stopping = false;
                this.stream = null;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));

      function stop(_x2) {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
    /**
     *
     * @param sessionId This parameter is a unique sessionId of type string.
     * @returns It returns Promise of either SessionData(reservationId, expiration, renderer, mainConnection and secondaryConnection) type or ProvisioningSessionData(checkBackIn, expiration, mainConnection and secondaryConnection)
     */

  }, {
    key: "getSessionData",
    value: function () {
      var _getSessionData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(sessionId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Http.get(this.serviceOptions, "/api/v1/session/".concat(sessionId));

              case 2:
                response = _context3.sent;

                if (!(response.Status === 404)) {
                  _context3.next = 7;
                  break;
                }

                throw new SessionNotFoundError();

              case 7:
                if (!(response.Status < 200 || response.Status > 299)) {
                  _context3.next = 11;
                  break;
                }

                throw new SessionNotAvailableError(SessionNotAvailableError.E_NO_AVAILABLE);

              case 11:
                if (!(response.Data.type == 'session')) {
                  _context3.next = 15;
                  break;
                }

                return _context3.abrupt("return", response.Data);

              case 15:
                return _context3.abrupt("return", response.Data);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getSessionData(_x3) {
        return _getSessionData.apply(this, arguments);
      }

      return getSessionData;
    }()
    /**
     *
     * @param sessionId This parameter is a unique sessionId of type string.
     * @returns It returns the Promise of type TwilioTokenData(includes token of type string).
     */

  }, {
    key: "getTwilioToken",
    value: function () {
      var _getTwilioToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(sessionId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Http.get(this.serviceOptions, "/api/v1/session/".concat(sessionId, "/twiliotoken"));

              case 2:
                response = _context4.sent;

                if (!(response.Status === 404)) {
                  _context4.next = 7;
                  break;
                }

                throw new SessionNotFoundError();

              case 7:
                if (!(response.Status < 200 || response.Status > 299)) {
                  _context4.next = 11;
                  break;
                }

                throw new Error();

              case 11:
                return _context4.abrupt("return", response.Data);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getTwilioToken(_x4) {
        return _getTwilioToken.apply(this, arguments);
      }

      return getTwilioToken;
    }()
    /**
     *
     * @param connectionKey This parameter is a unique connectionKey of type string.
     * @returns It returns Promise of either SessionData(reservationId, expiration, renderer, mainConnection and secondaryConnection) type or ProvisioningSessionData(checkBackIn, expiration, mainConnection and secondaryConnection)
     */

  }, {
    key: "getSessionDataByConnectionKey",
    value: function () {
      var _getSessionDataByConnectionKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(connectionKey) {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Http.get(this.serviceOptions, "/api/v1/connection/key/".concat(connectionKey));

              case 2:
                response = _context5.sent;

                if (!(response.Status === 404)) {
                  _context5.next = 7;
                  break;
                }

                throw new SessionNotFoundError();

              case 7:
                if (!(response.Status < 200 || response.Status > 299)) {
                  _context5.next = 11;
                  break;
                }

                throw new SessionNotAvailableError(SessionNotAvailableError.E_NO_AVAILABLE);

              case 11:
                if (!(response.Data.type == 'session')) {
                  _context5.next = 15;
                  break;
                }

                return _context5.abrupt("return", response.Data);

              case 15:
                return _context5.abrupt("return", response.Data);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getSessionDataByConnectionKey(_x5) {
        return _getSessionDataByConnectionKey.apply(this, arguments);
      }

      return getSessionDataByConnectionKey;
    }()
  }, {
    key: "startPollingForProvisioningSession",
    value: function startPollingForProvisioningSession(provisioningSession) {
      var _this = this;

      var executePoll =
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6() {
          var session;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.prev = 0;
                  _context6.next = 3;
                  return _this.getSessionData(provisioningSession.id);

                case 3:
                  session = _context6.sent;

                  if (_this.isProvisioningSessionData(session)) {
                    _context6.next = 7;
                    break;
                  }

                  _this.connectInternal(session);

                  return _context6.abrupt("return", 0);

                case 7:
                  return _context6.abrupt("return", session.checkBackIn);

                case 10:
                  _context6.prev = 10;
                  _context6.t0 = _context6["catch"](0);

                  _this.bail(_context6.t0);

                  return _context6.abrupt("return", 0);

                case 14:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, null, [[0, 10]]);
        }));

        return function executePoll() {
          return _ref.apply(this, arguments);
        };
      }();

      var poll =
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee7() {
          var sleepDelay;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  sleepDelay = provisioningSession.checkBackIn;

                case 1:
                  _context7.next = 3;
                  return new Promise(function (f) {
                    return setTimeout(f, sleepDelay * 1000);
                  });

                case 3:
                  _context7.next = 5;
                  return executePoll();

                case 5:
                  sleepDelay = _context7.sent;

                case 6:
                  if (sleepDelay) {
                    _context7.next = 1;
                    break;
                  }

                case 7:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function poll() {
          return _ref2.apply(this, arguments);
        };
      }();

      poll();
    }
  }, {
    key: "startInternal",
    value: function () {
      var _startInternal = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(sessionOptions) {
        var session, sessionData;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.createSession(sessionOptions);

              case 3:
                session = _context8.sent;

                if (!this.isProvisioningSessionData(session)) {
                  _context8.next = 8;
                  break;
                }

                if (!sessionOptions.waitForProvisioning) {
                  this.bail(new SessionProvisioningError(session));
                } else {
                  sessionOptions.waitForProvisioning();
                  this.startPollingForProvisioningSession(session);
                }

                _context8.next = 11;
                break;

              case 8:
                sessionData = session;
                _context8.next = 11;
                return this.connectInternal(sessionData);

              case 11:
                _context8.next = 16;
                break;

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8["catch"](0);
                this.bail(_context8.t0);

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 13]]);
      }));

      function startInternal(_x6) {
        return _startInternal.apply(this, arguments);
      }

      return startInternal;
    }()
  }, {
    key: "connectInternal",
    value: function () {
      var _connectInternal = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(sessionData) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return this.signaling.start('client', sessionData.renderer.rendererId, sessionData.mainConnection.connectionKey);

              case 3:
                _context9.next = 5;
                return this.call(sessionData);

              case 5:
                _context9.next = 10;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);
                this.bail(_context9.t0);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 7]]);
      }));

      function connectInternal(_x7) {
        return _connectInternal.apply(this, arguments);
      }

      return connectInternal;
    }()
  }, {
    key: "startWithConnectionKeyInternal",
    value: function () {
      var _startWithConnectionKeyInternal = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(connectionKey) {
        var session;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.getSessionForConnectionKey(connectionKey);

              case 3:
                session = _context10.sent;
                _context10.next = 6;
                return this.signaling.start('client', session.renderer.rendererId, connectionKey);

              case 6:
                _context10.next = 8;
                return this.call(session);

              case 8:
                _context10.next = 13;
                break;

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](0);
                this.bail(_context10.t0);

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 10]]);
      }));

      function startWithConnectionKeyInternal(_x8) {
        return _startWithConnectionKeyInternal.apply(this, arguments);
      }

      return startWithConnectionKeyInternal;
    }()
  }, {
    key: "startWithConnectionCodeInternal",
    value: function () {
      var _startWithConnectionCodeInternal = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(connectionCode) {
        var keyData;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return this.getConnectionKeyForConnectionCode(connectionCode);

              case 3:
                keyData = _context11.sent;
                _context11.next = 6;
                return this.startWithConnectionKeyInternal(keyData.connectionKey);

              case 6:
                _context11.next = 11;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);
                this.bail(_context11.t0);

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 8]]);
      }));

      function startWithConnectionCodeInternal(_x9) {
        return _startWithConnectionCodeInternal.apply(this, arguments);
      }

      return startWithConnectionCodeInternal;
    }()
  }, {
    key: "createSession",
    value: function () {
      var _createSession = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(sessionOptions) {
        var response, errorCode;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return Http.post(this.serviceOptions, '/api/v1/session', sessionOptions);

              case 3:
                response = _context12.sent;

                if (!(response.Status === 503)) {
                  _context12.next = 9;
                  break;
                }

                errorCode = response.headers.get('X-ErrorCode');
                this.bail(new SessionNotAvailableError(errorCode));
                _context12.next = 18;
                break;

              case 9:
                if (!(response.Status < 200 || response.Status > 299)) {
                  _context12.next = 13;
                  break;
                }

                this.bail(new Error("unexpected status code: ".concat(response.Status)));
                _context12.next = 18;
                break;

              case 13:
                if (!(response.Data.type == 'session')) {
                  _context12.next = 17;
                  break;
                }

                return _context12.abrupt("return", response.Data);

              case 17:
                return _context12.abrupt("return", response.Data);

              case 18:
                _context12.next = 23;
                break;

              case 20:
                _context12.prev = 20;
                _context12.t0 = _context12["catch"](0);
                this.bail(_context12.t0);

              case 23:
                return _context12.abrupt("return", null);

              case 24:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 20]]);
      }));

      function createSession(_x10) {
        return _createSession.apply(this, arguments);
      }

      return createSession;
    }()
  }, {
    key: "getSessionForConnectionKey",
    value: function () {
      var _getSessionForConnectionKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(connectionKey) {
        var response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return Http.get(this.serviceOptions, "/api/v1/connection/key/".concat(connectionKey));

              case 2:
                response = _context13.sent;

                if (!(response.Status === 404)) {
                  _context13.next = 7;
                  break;
                }

                throw new SessionNotFoundError();

              case 7:
                if (!(response.Status !== 200)) {
                  _context13.next = 9;
                  break;
                }

                throw new Error();

              case 9:
                return _context13.abrupt("return", response.Data);

              case 10:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getSessionForConnectionKey(_x11) {
        return _getSessionForConnectionKey.apply(this, arguments);
      }

      return getSessionForConnectionKey;
    }()
  }, {
    key: "getConnectionKeyForConnectionCode",
    value: function () {
      var _getConnectionKeyForConnectionCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(connectionCode) {
        var response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return Http.get(this.serviceOptions, "/api/v1/connection/code/".concat(connectionCode));

              case 2:
                response = _context14.sent;

                if (!(response.Status === 404)) {
                  _context14.next = 7;
                  break;
                }

                throw new SessionNotFoundError();

              case 7:
                if (!(response.Status !== 200)) {
                  _context14.next = 9;
                  break;
                }

                throw new Error();

              case 9:
                return _context14.abrupt("return", response.Data);

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getConnectionKeyForConnectionCode(_x12) {
        return _getConnectionKeyForConnectionCode.apply(this, arguments);
      }

      return getConnectionKeyForConnectionCode;
    }()
  }, {
    key: "bail",
    value: function bail(err) {
      var _a;

      this.stream = null;
      this.stopMonitoring();
      this.messageSubscription && this.messageSubscription.unsubscribe();
      this.messageSubscription = null;
      this.signaling.signOut();
      (_a = this.streamSource) === null || _a === void 0 ? void 0 : _a.error(err);
      this.streamSource = new Subject();
    }
  }, {
    key: "prepareStream",
    value: function prepareStream(options) {
      var _this2 = this;

      var _a;

      this.streamOptions = options || {};
      this.streamOptions.streamLimits = (_a = this.streamOptions.streamLimits) !== null && _a !== void 0 ? _a : DefaultLimits;
      this.connection = null;
      var ret$ = this.streamSource.asObservable();
      this.messageSubscription && this.messageSubscription.unsubscribe();
      this.messageSubscription = this.signaling.message$.subscribe(
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee15(message) {
          var answer, connectionAnswer, reply;
          return _regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  if (_this2.connection) {
                    _context15.next = 2;
                    break;
                  }

                  return _context15.abrupt("return");

                case 2:
                  if (message) {
                    _context15.next = 7;
                    break;
                  }

                  console.log('no message');
                  _context15.next = 6;
                  return _this2.stop();

                case 6:
                  return _context15.abrupt("return");

                case 7:
                  answer = JSON.parse(message);

                  if (!(answer.type === 'answer')) {
                    _context15.next = 12;
                    break;
                  }

                  _this2.connection.setRemoteDescription(answer).catch(function (error) {
                    console.log('set remote description failed');
                    console.log(error);
                  });

                  _context15.next = 47;
                  break;

                case 12:
                  if (!(answer.type === 'offer')) {
                    _context15.next = 37;
                    break;
                  }

                  _context15.prev = 13;
                  _context15.next = 16;
                  return _this2.connection.setRemoteDescription(answer);

                case 16:
                  _context15.next = 18;
                  return _this2.connection.createAnswer();

                case 18:
                  connectionAnswer = _context15.sent;
                  reply = {
                    type: 'answer',
                    sdp: connectionAnswer.sdp
                  };
                  console.log('sending answer ' + reply);
                  _context15.prev = 21;
                  _context15.next = 24;
                  return _this2.signaling.sendMessage(JSON.stringify(reply));

                case 24:
                  _context15.next = 29;
                  break;

                case 26:
                  _context15.prev = 26;
                  _context15.t0 = _context15["catch"](21);

                  _this2.bail(_context15.t0);

                case 29:
                  _context15.next = 35;
                  break;

                case 31:
                  _context15.prev = 31;
                  _context15.t1 = _context15["catch"](13);
                  console.log('set remote description failed');
                  console.log(_context15.t1);

                case 35:
                  _context15.next = 47;
                  break;

                case 37:
                  if (!(answer.candidate !== undefined)) {
                    _context15.next = 47;
                    break;
                  }

                  _context15.prev = 38;
                  _context15.next = 41;
                  return _this2.connection.addIceCandidate(answer);

                case 41:
                  console.log('addIceCandidate succeeded');
                  _context15.next = 47;
                  break;

                case 44:
                  _context15.prev = 44;
                  _context15.t2 = _context15["catch"](38);
                  console.log('add ice candidate failed');

                case 47:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, null, [[13, 31], [21, 26], [38, 44]]);
        }));

        return function (_x13) {
          return _ref3.apply(this, arguments);
        };
      }());
      return ret$;
    }
  }, {
    key: "createConfiguration",
    value: function createConfiguration(specs) {
      var turnServer = (specs === null || specs === void 0 ? void 0 : specs.turnServer) || (specs === null || specs === void 0 ? void 0 : specs.publicDomainName);
      var iceServers = [];

      if (turnServer) {
        iceServers.splice(iceServers.length, 0, {
          urls: ["turns:".concat(turnServer, ":443?transport=tcp")],
          username: 'test',
          credential: 'test',
          credentialType: 'password'
        });
      }

      return {
        iceServers: iceServers
      };
    }
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(session) {
        var _this3 = this;

        var connected, specs, configuration, desc, newSdp, body;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                connected = false;
                specs = session.renderer.specs;
                configuration = this.createConfiguration(session.renderer.specs);
                this.connection = new RTCPeerConnection(configuration);
                this.connection.oniceconnectionstatechange =
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee16() {
                  return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          if (!(connected && !_this3.stopping && (_this3.connection.iceConnectionState === 'disconnected' || _this3.connection.iceConnectionState === 'closed' || _this3.connection.iceConnectionState === 'failed'))) {
                            _context16.next = 4;
                            break;
                          }

                          console.log('ice connection lost');
                          _context16.next = 4;
                          return _this3.stop(new Error('RTC connection lost'));

                        case 4:
                        case "end":
                          return _context16.stop();
                      }
                    }
                  }, _callee16);
                }));

                this.connection.ontrack =
                /*#__PURE__*/
                function () {
                  var _ref5 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee17(e) {
                    var track, firstTrack;
                    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                      while (1) {
                        switch (_context17.prev = _context17.next) {
                          case 0:
                            track = !e.streams[0] ? e.transceiver.receiver.track : e.streams[0].getTracks()[0];
                            firstTrack = !_this3.stream;

                            if (firstTrack) {
                              connected = true;
                              _this3.stream = new MediaStream();
                            }

                            track.enabled = true;

                            _this3.stream.addTrack(track);

                            if (!firstTrack) {
                              _context17.next = 9;
                              break;
                            }

                            _this3.streamSource.next({
                              ip: session.renderer.ip,
                              stream: _this3.stream,
                              specs: specs,
                              session: session
                            });

                            _context17.next = 9;
                            return _this3.startMonitoring();

                          case 9:
                          case "end":
                            return _context17.stop();
                        }
                      }
                    }, _callee17);
                  }));

                  return function (_x15) {
                    return _ref5.apply(this, arguments);
                  };
                }();

                _context18.prev = 6;
                this.connection.addTransceiver('video', {
                  direction: 'recvonly'
                });

                if (this.streamOptions.useAudio) {
                  this.connection.addTransceiver('audio', {
                    direction: 'recvonly'
                  });
                }

                _context18.next = 11;
                return this.connection.createOffer();

              case 11:
                desc = _context18.sent;
                _context18.prev = 12;
                newSdp = Sdp.forceH264(desc.sdp, this.streamOptions.streamLimits.startBitrate, this.streamOptions.streamLimits.minBitrate, this.streamOptions.streamLimits.maxBitrate);

                if (this.streamOptions.useAudio) {
                  newSdp = Sdp.forceOpus(newSdp);
                }

                _context18.next = 21;
                break;

              case 17:
                _context18.prev = 17;
                _context18.t0 = _context18["catch"](12);
                this.bail(_context18.t0);
                return _context18.abrupt("return");

              case 21:
                desc.sdp = newSdp;
                body = {
                  type: 'offer',
                  sdp: desc.sdp
                };
                this.connection.setLocalDescription(desc);
                _context18.next = 26;
                return this.signaling.sendMessage(JSON.stringify(body));

              case 26:
                _context18.next = 31;
                break;

              case 28:
                _context18.prev = 28;
                _context18.t1 = _context18["catch"](6);
                this.bail(_context18.t1);

              case 31:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[6, 28], [12, 17]]);
      }));

      function call(_x14) {
        return _call.apply(this, arguments);
      }

      return call;
    }()
  }, {
    key: "startMonitoring",
    value: function () {
      var _startMonitoring = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var _a, _b, _c;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this.stopMonitoring();
                this.monitor = new StreamMonitor(this.connection, this.stream, this.streamOptions, (_c = (_b = (_a = this.streamOptions) === null || _a === void 0 ? void 0 : _a.cutStreamLimits) === null || _b === void 0 ? void 0 : _b.handler) !== null && _c !== void 0 ? _c : this.onMonitoringEvent.bind(this), this.cutStream.bind(this));
                _context19.next = 4;
                return this.monitor.start();

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function startMonitoring() {
        return _startMonitoring.apply(this, arguments);
      }

      return startMonitoring;
    }()
  }, {
    key: "stopMonitoring",
    value: function stopMonitoring() {
      if (this.monitor) {
        this.monitor.stop();
        this.monitor = null;
      }
    }
  }, {
    key: "onMonitoringEvent",
    value: function onMonitoringEvent(_) {
      return true;
    }
    /**
     *
     * @param data It takes data as parameter of LimitData(this can be either BitrateLimitData, NoFrameLimitData or LatencyLimitData) type.
     * @returns It returns void.
     */

  }, {
    key: "cutStream",
    value: function () {
      var _cutStream = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20(data) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                console.log(data);
                _context20.next = 3;
                return this.stop(new ConnectionCutError(data.type, data.message));

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function cutStream(_x16) {
        return _cutStream.apply(this, arguments);
      }

      return cutStream;
    }()
  }, {
    key: "isProvisioningSessionData",
    value: function isProvisioningSessionData(data) {
      return data.checkBackIn !== undefined;
    }
  }]);

  return StreamingService;
}();

var StreamMonitor =
/*#__PURE__*/
function () {
  function StreamMonitor(connection, stream, streamOptions, eventHandler, streamCut) {
    _classCallCheck(this, StreamMonitor);

    var _a, _b;

    this.connection = connection;
    this.stream = stream;
    this.streamOptions = streamOptions;
    this.eventHandler = eventHandler;
    this.streamCut = streamCut;
    this.measureInterval = (_b = (_a = this.streamOptions.cutStreamLimits) === null || _a === void 0 ? void 0 : _a.measureInterval) !== null && _b !== void 0 ? _b : 5000;
  }

  _createClass(StreamMonitor, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.startStatsTimer();

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      this.stopStatsTimer();
    }
  }, {
    key: "checkStats",
    value: function () {
      var _checkStats = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        var _this4 = this;

        var stats;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (this.connection) {
                  _context23.next = 3;
                  break;
                }

                this.stopStatsTimer();
                return _context23.abrupt("return");

              case 3:
                _context23.prev = 3;
                _context23.next = 6;
                return this.connection.getStats(this.stream.getVideoTracks()[0]);

              case 6:
                stats = _context23.sent;
                stats.forEach(
                /*#__PURE__*/
                function () {
                  var _ref6 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee22(report) {
                    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            if (!_this4.handleDatarateLimit(report)) {
                              _context22.next = 2;
                              break;
                            }

                            return _context22.abrupt("return");

                          case 2:
                            if (!_this4.handleLatencyLimit(report)) {
                              _context22.next = 4;
                              break;
                            }

                            return _context22.abrupt("return");

                          case 4:
                            if (!_this4.handleNoFramesLimit(report)) {
                              _context22.next = 6;
                              break;
                            }

                            return _context22.abrupt("return");

                          case 6:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee22);
                  }));

                  return function (_x17) {
                    return _ref6.apply(this, arguments);
                  };
                }());
                _context23.next = 14;
                break;

              case 10:
                _context23.prev = 10;
                _context23.t0 = _context23["catch"](3);
                console.log('error getting stats, stopping stats watcher');
                this.stopStatsTimer();

              case 14:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[3, 10]]);
      }));

      function checkStats() {
        return _checkStats.apply(this, arguments);
      }

      return checkStats;
    }()
  }, {
    key: "handleDatarateLimit",
    value: function handleDatarateLimit(report) {
      var now = report.timestamp;

      if (this.streamOptions.cutStreamLimits.bitrate && report.type === 'inbound-rtp' && report.mediaType === 'video') {
        var bitrate;
        var bytes = report.bytesReceived;

        if (this.timestampPrev) {
          bitrate = 8 * (bytes - this.bytesPrev) / (now - this.timestampPrev);
          bitrate = Math.floor(bitrate);
        }

        this.bytesPrev = bytes;
        this.timestampPrev = now;

        if (bitrate && bitrate >= this.streamOptions.cutStreamLimits.bitrate) {
          this.lastTimestampBitrateSuccessOrReport = now;
        }

        var reachCutoffBitrate = bitrate < this.streamOptions.cutStreamLimits.bitrate;
        var reachMeasureInterval = now - this.lastTimestampBitrateSuccessOrReport > this.measureInterval;

        if (bitrate && reachCutoffBitrate && reachMeasureInterval) {
          this.lastTimestampBitrateSuccessOrReport = now;
          var data = {
            type: ConnectionCutType.BITRATE,
            message: "bitrate is too low (".concat(bitrate, ")"),
            bitrateLimit: this.streamOptions.cutStreamLimits.bitrate,
            currentBitrate: bitrate
          };

          if (this.eventHandler(data)) {
            this.streamCut(data);
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "handleLatencyLimit",
    value: function handleLatencyLimit(report) {
      if (this.streamOptions.cutStreamLimits.latency && report.type === 'candidate-pair') {
        var latency = report.currentRoundTripTime * 1000;

        if (latency && latency > this.streamOptions.cutStreamLimits.latency) {
          var data = {
            type: ConnectionCutType.LATENCY,
            message: "latency is too high (".concat(latency, ")"),
            latencyLimit: this.streamOptions.cutStreamLimits.latency,
            currentLatency: latency
          };

          if (this.eventHandler(data)) {
            this.streamCut(data);
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "handleNoFramesLimit",
    value: function handleNoFramesLimit(report) {
      if (this.streamOptions.cutStreamLimits.noFrames && report.type === 'inbound-rtp' && report.mediaType === 'video') {
        var framesReceived = report.framesReceived;

        if (framesReceived && framesReceived > 1 && framesReceived === this.framesReceivedPrev) {
          var data = {
            type: ConnectionCutType.FRAMES,
            message: 'no frames received since last check'
          };

          if (this.eventHandler(data)) {
            this.streamCut(data);
            return true;
          }
        }

        this.framesReceivedPrev = framesReceived;
      }

      return false;
    }
  }, {
    key: "startStatsTimer",
    value: function () {
      var _startStatsTimer = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        var _this5 = this;

        var stats, hasStats;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(!this.streamOptions || !this.streamOptions.cutStreamLimits)) {
                  _context25.next = 2;
                  break;
                }

                return _context25.abrupt("return");

              case 2:
                this.stopStatsTimer();
                _context25.prev = 3;
                _context25.next = 6;
                return this.connection.getStats();

              case 6:
                stats = _context25.sent;
                hasStats = false;
                stats.forEach(function (_) {
                  hasStats = true;
                });

                if (hasStats) {
                  _context25.next = 11;
                  break;
                }

                throw new Error();

              case 11:
                this.statsTimer = timer(500, 500).subscribe(
                /*#__PURE__*/
                function () {
                  var _ref7 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee24(_) {
                    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            _context24.next = 2;
                            return _this5.checkStats();

                          case 2:
                          case "end":
                            return _context24.stop();
                        }
                      }
                    }, _callee24);
                  }));

                  return function (_x18) {
                    return _ref7.apply(this, arguments);
                  };
                }());
                _context25.next = 17;
                break;

              case 14:
                _context25.prev = 14;
                _context25.t0 = _context25["catch"](3);
                console.log('getting stats not supported, configured limits will not be enforced');

              case 17:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[3, 14]]);
      }));

      function startStatsTimer() {
        return _startStatsTimer.apply(this, arguments);
      }

      return startStatsTimer;
    }()
  }, {
    key: "stopStatsTimer",
    value: function stopStatsTimer() {
      if (this.statsTimer) {
        this.statsTimer.unsubscribe();
        this.statsTimer = null;
        this.bytesPrev = null;
        this.timestampPrev = null;
        this.framesReceivedPrev = null;
      }
    }
  }]);

  return StreamMonitor;
}();

var SignalingService =
/*#__PURE__*/
function () {
  function SignalingService(serviceOptions) {
    _classCallCheck(this, SignalingService);

    this.serviceOptions = serviceOptions;
    this.messageSource = new Subject();
    this.message$ = this.messageSource.asObservable();
    this.remote_peers = [];
  }

  _createClass(SignalingService, [{
    key: "start",
    value: function () {
      var _start2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26(name, remotePeerName, connectionKey) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.signIn(name, remotePeerName, connectionKey);

              case 2:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function start(_x19, _x20, _x21) {
        return _start2.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27(body) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (this.id) {
                  _context27.next = 2;
                  break;
                }

                throw Error('not signed into signaling');

              case 2:
                _context27.next = 4;
                return fetch(this.buildUrl("/message?peer_id=".concat(this.id, "&to=").concat(this.remote_id)), {
                  method: 'POST',
                  body: body,
                  headers: {
                    'X-AppEnvId': this.serviceOptions.appEnvId
                  }
                });

              case 4:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function sendMessage(_x22) {
        return _sendMessage.apply(this, arguments);
      }

      return sendMessage;
    }()
  }, {
    key: "signOut",
    value: function () {
      var _signOut = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        var id;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                this.stopPollingMessages();

                if (!this.id) {
                  _context28.next = 6;
                  break;
                }

                id = this.id;
                this.id = null;
                _context28.next = 6;
                return fetch(this.buildUrl("/sign_out?peer_id=".concat(id)), {
                  headers: {
                    'X-AppEnvId': this.serviceOptions.appEnvId
                  }
                });

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function signOut() {
        return _signOut.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: "signIn",
    value: function () {
      var _signIn = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29(name, remote_peer_name, connectionKey) {
        var response, errorCode, body;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return fetch(this.buildUrl("/sign_in?peer_name=".concat(name)), {
                  headers: {
                    ConnectionKey: connectionKey,
                    'X-AppEnvId': this.serviceOptions.appEnvId
                  }
                });

              case 2:
                response = _context29.sent;

                if (!(response.status === 400)) {
                  _context29.next = 8;
                  break;
                }

                errorCode = response.headers.get('X-ErrorCode');

                if (!(errorCode && errorCode === 'E_KEY_IN_USE')) {
                  _context29.next = 7;
                  break;
                }

                throw new ConnectionKeyInUseError();

              case 7:
                throw new SessionNotAvailableError(SessionNotAvailableError.E_NO_SIGNALING);

              case 8:
                if (!(response.status === 500)) {
                  _context29.next = 10;
                  break;
                }

                throw new SessionNotAvailableError(SessionNotAvailableError.E_NO_SIGNALING);

              case 10:
                this.id = response.headers.get('Pragma');
                _context29.next = 13;
                return response.text();

              case 13:
                body = _context29.sent;
                this.remote_peers = this.getSignalingClients(body);

                if (this.connect(remote_peer_name)) {
                  _context29.next = 17;
                  break;
                }

                throw Error('renderer not found on signaling server');

              case 17:
                this.startPollingMessages();

              case 18:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function signIn(_x23, _x24, _x25) {
        return _signIn.apply(this, arguments);
      }

      return signIn;
    }()
  }, {
    key: "startPollingMessages",
    value: function startPollingMessages() {
      if (!this.id) return;
      this.pollMessage();
    }
  }, {
    key: "stopPollingMessages",
    value: function stopPollingMessages() {
      if (this.messageAbort) {
        this.messageAbort.abort();
      }

      if (this.messageSource) {
        this.messageSource.complete();
        this.messageSource = new Subject();
        this.message$ = this.messageSource.asObservable();
      }
    }
  }, {
    key: "pollMessage",
    value: function pollMessage() {
      var _this6 = this;

      this.messageAbort = new AbortController();
      var signal = this.messageAbort.signal;
      fetch(this.buildUrl("/wait?peer_id=".concat(this.id)), {
        signal: signal,
        headers: {
          'X-AppEnvId': this.serviceOptions.appEnvId
        }
      }).then(
      /*#__PURE__*/
      function () {
        var _ref8 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee30(response) {
          return _regeneratorRuntime.wrap(function _callee30$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  if (!(response.status === 504)) {
                    _context30.next = 5;
                    break;
                  }

                  // longpolling timeout
                  _this6.pollMessage();

                  return _context30.abrupt("return");

                case 5:
                  if (!(response.status < 200 || response.status > 299)) {
                    _context30.next = 8;
                    break;
                  }

                  _this6.stopPollingMessages();

                  return _context30.abrupt("return");

                case 8:
                  if (!(response.headers.get('Pragma') !== _this6.id)) {
                    _context30.next = 14;
                    break;
                  }

                  _context30.t0 = _this6.messageSource;
                  _context30.next = 12;
                  return response.text();

                case 12:
                  _context30.t1 = _context30.sent;

                  _context30.t0.next.call(_context30.t0, _context30.t1);

                case 14:
                  _this6.pollMessage();

                case 15:
                case "end":
                  return _context30.stop();
              }
            }
          }, _callee30);
        }));

        return function (_x26) {
          return _ref8.apply(this, arguments);
        };
      }()).catch(function (e) {
        console.log(e);
      });
    }
  }, {
    key: "connect",
    value: function connect(remote_peer_name) {
      var remote = this.remote_peers.find(function (peer) {
        return peer.name.localeCompare(remote_peer_name, 'en', {
          sensitivity: 'base'
        }) === 0;
      });
      if (!remote) return false;
      this.remote_id = remote.id;
      return true;
    }
  }, {
    key: "getSignalingClients",
    value: function getSignalingClients(data) {
      var _this7 = this;

      var lines = data.split('\n').filter(Boolean);
      var peers = [];
      lines.forEach(function (line) {
        var values = line.split(',');
        var nameSplit = values[0].split(' ');
        var name = nameSplit[0];
        var remote_id = values[1];
        if (remote_id === _this7.id) return;
        var capacity = 'infinite';

        if (nameSplit.length > 1) {
          capacity = nameSplit[1].replace('(', '').replace(')', '');
        }

        var online = values[2] === '1';
        peers.push({
          id: remote_id,
          name: name,
          capacity: capacity,
          online: online
        });
      });
      return peers;
    }
  }, {
    key: "buildUrl",
    value: function buildUrl(path) {
      return "".concat(this.serviceOptions.baseUrl, "/signaling").concat(path);
    }
  }]);

  return SignalingService;
}();